module.exports = __webpack_public_path__ + "img/yifenpei.80cf39ec.png";